import MuiBox, { type BoxProps as MuiBoxProps } from '@mui/material/Box'
import MuiClickAwayListener, {
  type ClickAwayListenerProps as MuiClickAwayListenerProps,
} from '@mui/material/ClickAwayListener'
import MuiCollapse, { type CollapseProps as MuiCollapseProps } from '@mui/material/Collapse'
import MuiContainer, { type ContainerProps as MuiContainerProps } from '@mui/material/Container'
import MuiDivider, { type DividerProps as MuiDividerProps } from '@mui/material/Divider'
import MuiGrid, { type GridProps as MuiGridProps } from '@mui/material/Grid'
import MuiStack, { type StackProps as MuiStackProps } from '@mui/material/Stack'
import MuiPaper, { type PaperProps as MuiPaperProps } from '@mui/material/Paper'
import MuiList, { type ListProps as MuiListProps } from '@mui/material/List'
import MuiListItem, { type ListItemProps as MuiListItemProps } from '@mui/material/ListItem'
import MuiListItemButton, { type ListItemButtonProps as MuiListItemButtonProps } from '@mui/material/ListItemButton'
import MuiListItemIcon, { type ListItemIconProps as MuiListItemIconProps } from '@mui/material/ListItemIcon'
import MuiListItemText, { type ListItemTextProps as MuiListItemTextProps } from '@mui/material/ListItemText'

//* BOX
export const Box = MuiBox
export type BoxProps = MuiBoxProps

//* CLICK AWAY LISTENER
export const ClickAwayListener = MuiClickAwayListener
export type ClickAwayListenerProps = MuiClickAwayListenerProps

//* COLLAPSE
export const Collapse = MuiCollapse
export type CollapseProps = MuiCollapseProps

//* CONTAINER
export const Container = MuiContainer
export type ContainerProps = MuiContainerProps

//* DIVIDER
export const Divider = MuiDivider
export type DividerProps = MuiDividerProps

//* GRID
export const Grid = MuiGrid
export type GridProps = MuiGridProps

//* STACK
export const Stack = MuiStack
export type StackProps = MuiStackProps

//* PAPER
export const Paper = MuiPaper
export type PaperProps = MuiPaperProps

//* LIST
export const List = MuiList
export type ListProps = MuiListProps

//* LIST ITEM
export const ListItem = MuiListItem
export type ListItemProps = MuiListItemProps

//* LIST ITEM BUTTON
export const ListItemButton = MuiListItemButton
export type ListItemButtonProps = MuiListItemButtonProps

//* LIST ITEM ICON
export const ListItemIcon = MuiListItemIcon
export type ListItemIconProps = MuiListItemIconProps

//* LIST ITEM TEXT
export const ListItemText = MuiListItemText
export type ListItemTextProps = MuiListItemTextProps
